export default {
  methods: {
    back: function back() {
      var _this = this;
      var timer = setTimeout(function () {
        _this.$router.back();
        clearTimeout(timer);
      }, 100);
    }
  }
};